<template>
  <div class="homeGrab">
    <div class="w-1180px mx-auto c3 tracking-2px pt-58px fs16">
      <div>
        <div class="text-center">
          <p class="fs32 font-600">API超市-产品介绍</p>
          <p class="fs22 c9">Product Introduction</p>
        </div>
        <div class="flex justify-center items-center mt-40px">
          <div class="pr-285px">
            <p class="font-500 fs26">API接口超市，开张啦！</p>
            <p class="lh32 pt-24px">
              告别信息孤岛，一起加入信息互联的世界！<br />
              全量接口开放，一站式自助对接<br />
              物流信息化，本该如此！
            </p>
            <!-- 现在先不打开QQ -->
            <el-button class="btn fs20 lh10" type="primary" @click="openQQ">立即试用</el-button>
          </div>
          <!-- <img width="414" :src="`${ossUrl}/common/market_v2/home/ams-1.png`" /> -->
          <img width="414" src="@/assets/images/api/top-r.png" />
        </div>
      </div>
      <div class="pt-80px">
        <div class="text-center pb-40px">
          <p class="fs32 font-600">产品优势</p>
          <p class="fs22 c9">Product Advantage</p>
        </div>
        <div class="middle-content relative">
          <!-- <div class="mx-40px">
            <p class="fs26 font-500 block">{{ v.title }}</p>
            <p class="block-1 pl-16px mt-30px" v-html="v.txt"></p>
          </div>
          <img class="w-625px mx-40px" :src="v.img" /> -->
          <img class="absolute -z-1" src="../../assets/images/api/content.png" alt="" width="100%" />
          <div v-for="(item, index) in advantage" :key="index" class="content-box">
            <div class="line"></div>
            <div class="fs24 title">{{ item.title }}</div>
            <div v-for="(v, idx) in item.txt" :key="idx" style="display: flex; align-items: baseline"><span class="dot"></span><span v-html="v"></span></div>
          </div>
        </div>
      </div>
      <div v-if="flow.length > 0" class="pt-80px pb-60px">
        <div class="text-center pb-40px">
          <p class="fs32 font-600">对接流程</p>
          <p class="fs22 c9">Docking Process</p>
        </div>
        <!-- <div>
          <img
            class="mx-auto mb-30px"
            :src="`${ossUrl}/common/market_v2/home/cpsqd-5.png`"
          />
        </div> -->
        <div class="flex">
          <div
            v-for="(v, i) in flow"
            :key="i"
            class="text-center"
            :class="{
              '-ml-5px': i === 0,
              'ml-126px': i === 1,
              'transform translate-x-124px': i === 2
            }"
          >
            <img class="mx-auto w-110px mb-30px" :src="v.img" />
            <p class="c3 fs24 tracking-2px font-500">{{ v.title }}</p>
            <p class="tracking-1px c6 pt-8px" v-html="v.txt"></p>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 142px">
      <div :class="!offetHeight ? 'fixed' : ''">
        <ContectPhone />
      </div>
    </div>
  </div>
</template>

<script>
import ContectPhone from '../../components/ContectPhone'

// import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
export default {
  components: {
    ContectPhone
  },
  data() {
    return {
      ossUrl,
      advantage: [
        {
          title: '实时高效的数据传输与回执获取',
          txt: ['我们的时间，为什么要浪费在重复低级的数据录入之上？', '让繁杂的数据发送和查询实现一键传送，互联互通，你的精力，<br/>可以专注在更加重要的领域！']
        },
        {
          title: '一套接口，连通全量产品',
          txt: ['e航无忧全量产品，均已加入API超市豪华全家桶，并在不断丰富<br/>与升级中！', '我们更欢迎所有友商伙伴的加入，共建生态，互惠共赢！']
        },
        {
          title: '0门槛在线自助调测，专业人员1V1全流程引导',
          txt: ['我们提供在线自助调测的工具，完成测试直接开始调用，为您免去反复<br/>切换系统的麻烦', '专业的程序猿小哥哥，也将全程在线，提供1V1全流程指引，你的一切<br/>后顾之忧，均可抛诸脑后！']
        },
        {
          title: '校验规则，全线开放共享',
          txt: ['e航无忧平台累积的所有数据校验规则，我们均会在接口层面无偿<br/>开放共享！', '我们希望和每一个物流人一起，一起走向星辰大海！']
        }
      ],
      flow: [
        {
          title: 'Step 1：完成企业认证',
          txt: '我们的API接口向平台所有用户开放，您<br/>只需完成企业认证即可开启对接，无任何<br/>额外门槛和费用！',
          //   img: `${ossUrl}/common/market_v2/home/cpsqd-6.png`,
          img: require('../../assets/images/api/step1.png')
        },
        {
          title: 'Step 2：完成接口调测',
          txt: '选择您希望对接的接口，完成调测我们<br/>的专业工程师，将随时待命提供线下的<br/>协助',
          //   img: `${ossUrl}/common/market_v2/home/cpsqd-7.png`,
          img: require('../../assets/images/api/step2.png')
        },
        {
          title: 'Step 3：开始使用',
          txt: '在您的自有系统内，开始互联互<br/>通的一键式操作吧！',
          //   img: `${ossUrl}/common/market_v2/home/cpsqd-8.png`,
          img: require('../../assets/images/api/step3.png')
        }
      ],
      offetHeight: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  methods: {
    openQQ() {
      const isLogin = this.$store.state.user.isLogin || false
      if (!isLogin) {
        this.$message.error('未登录,请登录后再试')
        return
      }

      location.href = '/apistore'
    },
    // 获取页面滚动距离
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight

      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

      const scrollBottom = scrollHeight - windowHeight - scrollTop
      if (scrollBottom <= 424) {
        this.offetHeight = true
      } else {
        this.offetHeight = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.homeGrab {
  position: relative;
  //   background-image: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/rpa_2.0_home/banner-case.png);
  //   background-position: center calc(100% + 410px);
  //   background-repeat: no-repeat;
  .btn {
    width: 140px;
    height: 42px;
    background-color: #0f71ef;
    border-color: #0f71ef;
    border-radius: 4px;
    margin-top: 24px;
  }
  .middle-content {
    width: 1180px;
    height: 1675px;
    // background-image: url('../../assets/images/api/content.png');
    // background-position: left top;
    // background-repeat: no-repeat;
  }
  .line {
    width: 50px;
    height: 6px;
    background: linear-gradient(270deg, #ffffff 0%, #0f71ef 100%);
  }
  .content-box {
    padding-left: 75px;
    .title {
      font-weight: 500;
      color: #333333;
      margin-top: 24px;
      line-height: 30px;
      margin-bottom: 34px;
    }
    .dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #1d7af0;
      border-radius: 100px;
      margin-right: 8px;
    }
  }
  .content-box:nth-of-type(1) {
    padding-top: 102px;
  }
  .content-box:nth-of-type(2) {
    position: absolute;
    top: 525px;
    right: 0;
  }
  .content-box:nth-of-type(3) {
    position: absolute;
    top: 962px;
    // left: 75px;
  }
  .content-box:nth-of-type(4) {
    position: absolute;
    top: 1403px;
    right: 0;
  }
  .fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
